export const solutionsMenu = [
    { txt: '医药数字化营销', id: '/solution-yq', name: 'yq' },
    { txt: '互联网医院', id: '/solution-hy', name: 'hy' },
    { txt: '健康门诊险', id: '/solution-bs', name: 'bs' },
    { txt: '企业健康管理', id: '/solution-qy', name: 'qy' },
    { txt: '药店新零售', id: '/solution-yd', name: 'yd' },
    { txt: '医联体/医共体', id: '/solution-zf', name: 'zf' },
]
